export default "__VITE_ASSET__Kfg3imGb__"